import { KeyCode } from '@tencent/docs-keymap';

/*
 * @FilePath: /workbench/packages/workbench/src/constants/accessibility-operation-type.ts
 * @Description: 无障碍键盘操作类型、操作键等配置参数
 * @Date: 2021-08-03 12:36:05
 * @Author: astridli
 * ----
 * Copyright (c) 2021 Tencent
 */
/** 无障碍键盘操作类型 */
var AccessibilityKeyDownType;
(function (AccessibilityKeyDownType) {
    AccessibilityKeyDownType["ENTER"] = "\u89E6\u53D1\u9F20\u6807click\u4E8B\u4EF6\uFF08\u6253\u5F00\u5B50\u9879\uFF09";
    AccessibilityKeyDownType["EXIT"] = "\u9000\u51FA\u5F53\u524D\u9879\u76EE";
    AccessibilityKeyDownType["LEFT_ITEM"] = "\u00A0\u9009\u4E2D\u5DE6\u8FB9\u7684\u5B50\u9879";
    AccessibilityKeyDownType["RIGHT_ITEM"] = "\u00A0\u9009\u4E2D\u53F3\u8FB9\u7684\u5B50\u9879";
    AccessibilityKeyDownType["DEFAULT"] = "\u65E0\u64CD\u4F5C";
})(AccessibilityKeyDownType || (AccessibilityKeyDownType = {}));
/** 无障碍 键盘操作对应关系 */
const AccessibilityKeyCodes = {
    [KeyCode.ARROW_RIGHT]: AccessibilityKeyDownType.RIGHT_ITEM,
    [KeyCode.ARROW_LEFT]: AccessibilityKeyDownType.LEFT_ITEM,
    [KeyCode.ARROW_UP]: AccessibilityKeyDownType.ENTER,
    [KeyCode.ARROW_DOWN]: AccessibilityKeyDownType.ENTER,
    [KeyCode.SPACE]: AccessibilityKeyDownType.ENTER,
    [KeyCode.ENTER]: AccessibilityKeyDownType.ENTER,
    [KeyCode.ESCAPE]: AccessibilityKeyDownType.EXIT,
};
/** 焦点在toolbar 子项移动操作类型 */
var OperationItemType;
(function (OperationItemType) {
    OperationItemType["LEFT"] = "\u7126\u70B9\u79FB\u52A8\u5230\u5F53\u524D\u5B50\u9879\u6309\u94AE\u7684\u76F8\u5BF9\u4F4D\u7F6E\u5DE6\u8FB9\u5B50\u9879\u6309\u94AE";
    OperationItemType["RIGHT"] = "\u7126\u70B9\u79FB\u52A8\u5230\u5F53\u524D\u5B50\u9879\u6309\u94AE\u7684\u76F8\u5BF9\u4F4D\u7F6E\u53F3\u8FB9\u5B50\u9879\u6309\u94AE";
})(OperationItemType || (OperationItemType = {}));
/** 【中文】无障碍读屏术语 */
var AccessibilityChineseScreenReadingTerms;
(function (AccessibilityChineseScreenReadingTerms) {
    AccessibilityChineseScreenReadingTerms["TOOLBAR"] = "\u5DE5\u5177\u680F\uFF0C\u7528\u4E8E\u5BF9\u6B63\u6587\u5185\u5BB9\u8FDB\u884C\u8865\u5145\u4FEE\u6539";
    AccessibilityChineseScreenReadingTerms["TOOLBAR_PINNED"] = "\u6536\u8D77\u6216\u663E\u793A\u5DE5\u5177\u680F\u6309\u94AE";
})(AccessibilityChineseScreenReadingTerms || (AccessibilityChineseScreenReadingTerms = {}));

export { AccessibilityChineseScreenReadingTerms, AccessibilityKeyCodes, AccessibilityKeyDownType, OperationItemType };
//# sourceMappingURL=accessibility-operation-type.js.map
